import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from 'react-i18next'

import en from "./i18n/en.json";
import bn from "./i18n/bn.json";
import de from "./i18n/de.json";
import es from "./i18n/es.json";
import fr from "./i18n/fr.json";
import ptPT from "./i18n/pt-PT.json";
import ar from "./i18n/ar.json";
import ta from "./i18n/ta.json";
import hi from "./i18n/hi.json";
import bo from "./i18n/bo.json";
import cs from "./i18n/cs.json";
import pl from "./i18n/pl.json";
import ru from "./i18n/ru.json";
import uk from "./i18n/uk.json";
import sw from "./i18n/sw.json";
import zu from "./i18n/zu.json";
import it from "./i18n/it.json";
import km from "./i18n/km.json";
import nl from "./i18n/nl.json";
import ms from "./i18n/ms.json";
import id from "./i18n/id.json";
import ja from "./i18n/ja.json";
import ko from "./i18n/ko.json";
import th from "./i18n/th.json";
import lo from "./i18n/lo.json";
import my from "./i18n/my.json";
import vi from "./i18n/vi.json";
import fil from "./i18n/fil.json";
import mn from "./i18n/mn.json";
import ur from "./i18n/ur.json";
import ne from "./i18n/ne.json";
import si from "./i18n/si.json";
import mi from "./i18n/mi.json";
import tpi from "./i18n/tpi.json";
import hmo from "./i18n/hmo.json";
import fj from "./i18n/fj.json";
import hif from "./i18n/hif.json";
import to from "./i18n/to.json";
import bi from "./i18n/bi.json";
import rar from "./i18n/rar.json";
import sm from "./i18n/sm.json";
import am from "./i18n/am.json";
import om from "./i18n/om.json";
import zn from "./i18n/zh-Hans.json";
import zh from "./i18n/zh-Hans.json";


i18n
  .use(LanguageDetector) // auto detect user language
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      bn: { translation: bn },
      de: { translation: de },
      es: { translation: es },
      fr: { translation: fr },
      pt: { translation: ptPT },
      ar: { translation: ar },
      ta: { translation: ta },
      hi: { translation: hi },
      bo: { translation: bo },
      cs: { translation: cs },
      pl: { translation: pl },
      ru: { translation: ru },
      uk: { translation: uk },
      sw: { translation: sw },
      zu: { translation: zu },
      it: { translation: it },
      km: { translation: km },
      nl: { translation: nl },
      ms: { translation: ms },
      id: { translation: id },
      ja: { translation: ja },
      ko: { translation: ko },
      th: { translation: th },
      lo: { translation: lo },
      my: { translation: my },
      vi: { translation: vi },
      fil: { translation: fil },
      mn: { translation: mn },
      ur: { translation: ur },
      ne: { translation: ne },
      si: { translation: si },
      mi: { translation: mi },
      tpi: { translation: tpi },
      hmo: { translation: hmo },
      fj: { translation: fj },
      hif: { translation: hif },
      to: { translation: to },
      bi: { translation: bi },
      rar: { translation: rar },
      sm: { translation: sm },
      am: { translation: am },
      om: { translation: om },
      "zh-Hans": { translation: zn },
      "zh-Hant": { translation: zh },
    },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // React already escapes
    },
  });

export default i18n;